"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usersSaga = exports.sendUserCreationLimitChangeRequestEmail = exports.sendDemandContactUsRequestEmail = exports.deleteUserDeactivation = exports.createUserDeactivations = exports.getDeactivationUsers = exports.userVerification = exports.userPasswordReset = exports.getUserByUuidRequest = exports.deleteAccessToken = exports.getRichAccessTokenById = exports.getRichAccessTokenByUuid = exports.updateUserRequest = exports.toggleDuplicate = exports.createUserSaga = exports.getUserAccessByUuidRequest = exports.getUserByUuid = exports.getUsersAccess = exports.getUsers = void 0;
var antd_1 = require("antd");
var chunk_1 = __importDefault(require("lodash/chunk"));
var keyBy_1 = __importDefault(require("lodash/keyBy"));
var effects_1 = require("redux-saga/effects");
var auth_client_1 = require("@evenfinancial/auth-client");
var api_client_1 = require("@portal/api-client");
var common_1 = require("@portal/common");
var actionTypes_1 = require("./actionTypes");
var actions = __importStar(require("./actions"));
var selectors_1 = require("./selectors");
function getUsers() {
    var data, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4, (0, effects_1.call)(api_client_1.client.get, '/user')];
            case 1:
                data = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.userRequestAction.success(data))];
            case 2:
                _a.sent();
                return [3, 5];
            case 3:
                err_1 = _a.sent();
                return [4, (0, effects_1.put)(actions.userRequestAction.failure(err_1))];
            case 4:
                _a.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.getUsers = getUsers;
function getUsersAccess() {
    var data, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4, (0, effects_1.call)(api_client_1.client.get, '/user/access')];
            case 1:
                data = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.userAccessRequestAction.success(data))];
            case 2:
                _a.sent();
                return [3, 5];
            case 3:
                err_2 = _a.sent();
                return [4, (0, effects_1.put)(actions.userAccessRequestAction.failure(err_2))];
            case 4:
                _a.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.getUsersAccess = getUsersAccess;
function getUserByUuid(action) {
    var accessTokenById, uuid, user, err_3, router;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 10]);
                return [4, (0, effects_1.select)(function (state) { return state; })];
            case 1:
                accessTokenById = (_a.sent()).user.accessTokenById;
                uuid = action.payload.uuid;
                return [4, (0, effects_1.call)(api_client_1.client.get, "/user/".concat(uuid))];
            case 2:
                user = (_a.sent()).data;
                if (!(user.createdById &&
                    !Object.prototype.hasOwnProperty.call(accessTokenById, user.createdById))) return [3, 4];
                return [4, (0, effects_1.put)(actions.richAccessTokenByIdRequestAction.request({
                        id: user.createdById,
                    }))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4, (0, effects_1.put)(actions.userByUuidRequestAction.success(user))];
            case 5:
                _a.sent();
                return [3, 10];
            case 6:
                err_3 = _a.sent();
                return [4, (0, effects_1.getContext)('Router')];
            case 7:
                router = _a.sent();
                return [4, (0, effects_1.call)([router, 'replace'], '/404')];
            case 8:
                _a.sent();
                return [4, (0, effects_1.put)(actions.userByUuidRequestAction.failure(err_3))];
            case 9:
                _a.sent();
                return [3, 10];
            case 10: return [2];
        }
    });
}
exports.getUserByUuid = getUserByUuid;
function getUserAccessByUuidRequest(action) {
    var uuid, data, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                uuid = action.payload.uuid;
                return [4, (0, effects_1.call)(api_client_1.client.get, "/user/".concat(uuid, "/access"))];
            case 1:
                data = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.userAccessByUuidRequestAction.success(data))];
            case 2:
                _a.sent();
                return [3, 5];
            case 3:
                err_4 = _a.sent();
                return [4, (0, effects_1.put)(actions.userAccessByUuidRequestAction.failure(err_4))];
            case 4:
                _a.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.getUserAccessByUuidRequest = getUserAccessByUuidRequest;
function createUserSaga(action) {
    var _a, accounts, allAccounts_1, subAccounts, roleObject, supplySubAccounts, demandSubAccounts, partnerType, demandRole, supplyRole, formParams, roles, isInternal, getUuids, newSubAccounts, newRoles, shouldForceCurrentUserRolesOnUserCreation, data, createdUser, err_5, portalError;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 10, , 12]);
                _a = action.payload, accounts = _a.accounts, allAccounts_1 = _a.allAccounts, subAccounts = _a.subAccounts, roleObject = _a.roleObject, supplySubAccounts = _a.supplySubAccounts, demandSubAccounts = _a.demandSubAccounts, partnerType = _a.partnerType, demandRole = _a.demandRole, supplyRole = _a.supplyRole, formParams = __rest(_a, ["accounts", "allAccounts", "subAccounts", "roleObject", "supplySubAccounts", "demandSubAccounts", "partnerType", "demandRole", "supplyRole"]);
                return [4, (0, effects_1.select)(selectors_1.selectUserRoles)];
            case 1:
                roles = _c.sent();
                isInternal = partnerType === undefined;
                getUuids = function (items) {
                    if (allAccounts_1 === 'true' || Boolean(allAccounts_1) === true) {
                        return [];
                    }
                    return items === null || items === void 0 ? void 0 : items.map(function (item) {
                        if (typeof item === 'object') {
                            return item.uuid;
                        }
                        return item;
                    });
                };
                newSubAccounts = [];
                if (supplySubAccounts === null || supplySubAccounts === void 0 ? void 0 : supplySubAccounts.length) {
                    newSubAccounts.push.apply(newSubAccounts, supplySubAccounts);
                }
                if (demandSubAccounts === null || demandSubAccounts === void 0 ? void 0 : demandSubAccounts.length) {
                    newSubAccounts.push.apply(newSubAccounts, demandSubAccounts);
                }
                newRoles = [];
                if (demandRole) {
                    newRoles.push.apply(newRoles, demandRole.roles);
                }
                if (supplyRole) {
                    newRoles.push.apply(newRoles, supplyRole.roles);
                }
                if (roleObject) {
                    newRoles.push.apply(newRoles, roleObject.roles);
                }
                return [4, (0, effects_1.select)(selectors_1.selectPermissions)];
            case 2:
                shouldForceCurrentUserRolesOnUserCreation = (_c.sent()).shouldForceCurrentUserRolesOnUserCreation;
                data = __assign(__assign({}, formParams), { accountUuids: getUuids(accounts), emailAddress: (_b = formParams.emailAddress) === null || _b === void 0 ? void 0 : _b.trim(), roles: shouldForceCurrentUserRolesOnUserCreation ? roles : newRoles, subAccountUuids: isInternal
                        ? getUuids(subAccounts)
                        : getUuids(newSubAccounts) });
                return [4, (0, effects_1.call)(api_client_1.createUser, data)];
            case 3:
                createdUser = _c.sent();
                return [4, (0, effects_1.put)(actions.userCreateRequestAction.success(createdUser))];
            case 4:
                _c.sent();
                return [4, (0, effects_1.put)(actions.userRequestAction.request({}))];
            case 5:
                _c.sent();
                return [4, (0, effects_1.put)(actions.userAccessRequestAction.request({}))];
            case 6:
                _c.sent();
                return [4, (0, effects_1.put)(actions.toggleCreateUser())];
            case 7:
                _c.sent();
                return [4, (0, effects_1.delay)(100)];
            case 8:
                _c.sent();
                return [4, (0, effects_1.call)([antd_1.message, 'success'], 'The user was created successfully')];
            case 9:
                _c.sent();
                return [3, 12];
            case 10:
                err_5 = _c.sent();
                portalError = (0, common_1.getPortalError)(err_5);
                return [4, (0, effects_1.put)(actions.userCreateRequestAction.failure(portalError))];
            case 11:
                _c.sent();
                return [3, 12];
            case 12: return [2];
        }
    });
}
exports.createUserSaga = createUserSaga;
function toggleDuplicate(action) {
    var uuid, err_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                uuid = action.payload;
                return [4, (0, effects_1.all)([
                        (0, effects_1.put)(actions.userByUuidRequestAction.request({ uuid: uuid })),
                        (0, effects_1.put)(actions.userAccessByUuidRequestAction.request({ uuid: uuid })),
                    ])];
            case 1:
                _a.sent();
                return [4, (0, effects_1.put)(actions.toggleDuplicateOpen(uuid))];
            case 2:
                _a.sent();
                return [3, 4];
            case 3:
                err_6 = _a.sent();
                return [2, err_6];
            case 4: return [2];
        }
    });
}
exports.toggleDuplicate = toggleDuplicate;
function updateUserRequest(action) {
    var _a, access, user, form, updateData, accountUuids, subAccountUuids, emailAddress, firstName, lastName, roles, mergedUpdateData, updatedUser, err_7;
    var _b, _c, _d, _e, _f, _g, _h, _j;
    return __generator(this, function (_k) {
        switch (_k.label) {
            case 0:
                _k.trys.push([0, 5, , 8]);
                _a = action.payload, access = _a.access, user = _a.user, form = _a.form;
                updateData = (0, common_1.toUserUpdateData)(form);
                accountUuids = (_c = (_b = updateData === null || updateData === void 0 ? void 0 : updateData.accountUuids) !== null && _b !== void 0 ? _b : access.grants.accounts) !== null && _c !== void 0 ? _c : [];
                subAccountUuids = (_e = (_d = updateData === null || updateData === void 0 ? void 0 : updateData.subAccountUuids) !== null && _d !== void 0 ? _d : access.grants.subaccounts) !== null && _e !== void 0 ? _e : [];
                emailAddress = (_f = updateData === null || updateData === void 0 ? void 0 : updateData.emailAddress) !== null && _f !== void 0 ? _f : user.emailAddress;
                firstName = (_g = updateData === null || updateData === void 0 ? void 0 : updateData.firstName) !== null && _g !== void 0 ? _g : user.firstName;
                lastName = (_h = updateData === null || updateData === void 0 ? void 0 : updateData.lastName) !== null && _h !== void 0 ? _h : user.lastName;
                roles = (_j = updateData === null || updateData === void 0 ? void 0 : updateData.roles) !== null && _j !== void 0 ? _j : access.roles;
                mergedUpdateData = {
                    accountUuids: accountUuids,
                    emailAddress: emailAddress,
                    firstName: firstName,
                    lastName: lastName,
                    roles: roles,
                    subAccountUuids: subAccountUuids,
                };
                return [4, (0, effects_1.call)(api_client_1.updateUser, user.uuid, mergedUpdateData)];
            case 1:
                updatedUser = _k.sent();
                return [4, (0, effects_1.put)(actions.updateUserRequestAction.success(updatedUser))];
            case 2:
                _k.sent();
                return [4, (0, effects_1.put)(actions.userByUuidRequestAction.request({ uuid: updatedUser.uuid }))];
            case 3:
                _k.sent();
                return [4, (0, effects_1.put)(actions.userAccessByUuidRequestAction.request({ uuid: updatedUser.uuid }))];
            case 4:
                _k.sent();
                setTimeout(function () { return antd_1.message.success('The user was updated successfully'); }, 100);
                return [3, 8];
            case 5:
                err_7 = _k.sent();
                return [4, (0, effects_1.put)(actions.updateUserRequestAction.failure(err_7))];
            case 6:
                _k.sent();
                return [4, (0, effects_1.call)([antd_1.message, 'error'], 'There was an error updating the user')];
            case 7:
                _k.sent();
                return [3, 8];
            case 8: return [2];
        }
    });
}
exports.updateUserRequest = updateUserRequest;
function getRichAccessTokenByUuid(action) {
    var chunkedList, richAccessTokens, err_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                return [4, (0, effects_1.call)(chunk_1.default, action.payload.uuids, 40)];
            case 1:
                chunkedList = _a.sent();
                return [4, (0, effects_1.all)(chunkedList.map(function (chunk) {
                        return (0, effects_1.call)(api_client_1.getRichAccessTokens, { accessTokenUuids: chunk });
                    }))];
            case 2:
                richAccessTokens = _a.sent();
                return [4, (0, effects_1.put)(actions.richAccessTokenByUuidRequestAction.success((0, keyBy_1.default)(richAccessTokens.flatMap(function (t) { return t; }), 'uuid')))];
            case 3:
                _a.sent();
                return [3, 6];
            case 4:
                err_8 = _a.sent();
                return [4, (0, effects_1.put)(actions.richAccessTokenByUuidRequestAction.failure(err_8))];
            case 5:
                _a.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
exports.getRichAccessTokenByUuid = getRichAccessTokenByUuid;
function getRichAccessTokenById(action) {
    var id, richAccessTokens, err_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                id = action.payload.id;
                return [4, (0, effects_1.call)(api_client_1.getRichAccessTokens, { id: id })];
            case 1:
                richAccessTokens = _a.sent();
                if (!richAccessTokens.length) return [3, 3];
                return [4, (0, effects_1.put)(actions.richAccessTokenByIdRequestAction.success({
                        id: id,
                        richAccessToken: richAccessTokens[0],
                    }))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [3, 6];
            case 4:
                err_9 = _a.sent();
                return [4, (0, effects_1.put)(actions.richAccessTokenByIdRequestAction.failure(err_9))];
            case 5:
                _a.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
exports.getRichAccessTokenById = getRichAccessTokenById;
function deleteAccessToken(action) {
    var err_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4, (0, effects_1.call)(api_client_1.client.delete, "/auth/access_tokens/".concat(action.payload.uuid))];
            case 1:
                _a.sent();
                return [4, (0, effects_1.put)(actions.deleteAccessTokenByUuid.success({
                        subAccountUuid: action.payload.subAccountUuid,
                        uuid: action.payload.uuid,
                    }))];
            case 2:
                _a.sent();
                setTimeout(function () { return antd_1.message.success('The access token was deleted successfully'); }, 100);
                return [3, 5];
            case 3:
                err_10 = _a.sent();
                return [4, (0, effects_1.put)(actions.deleteAccessTokenByUuid.failure(err_10))];
            case 4:
                _a.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.deleteAccessToken = deleteAccessToken;
function getUserByUuidRequest(_a) {
    var usersByUuid, err_11;
    var uuid = _a.uuid;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 5]);
                if (!uuid) return [3, 3];
                return [4, (0, effects_1.select)(selectors_1.selectUsersByUuid)];
            case 1:
                usersByUuid = _b.sent();
                if (!!Object.prototype.hasOwnProperty.call(usersByUuid, uuid)) return [3, 3];
                return [4, (0, effects_1.put)(actions.userByUuidRequestAction.request({ uuid: uuid }))];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3: return [3, 5];
            case 4:
                err_11 = _b.sent();
                return [2, err_11];
            case 5: return [2];
        }
    });
}
exports.getUserByUuidRequest = getUserByUuidRequest;
function userPasswordReset(action) {
    var err_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4, (0, effects_1.call)(api_client_1.client.post, "/user/".concat(action.payload, "/reset_password"))];
            case 1:
                _a.sent();
                return [4, (0, effects_1.put)(actions.userPwResetAction.success())];
            case 2:
                _a.sent();
                setTimeout(function () {
                    return antd_1.message.success('A password reset email has been sent to the user.');
                }, 100);
                return [3, 5];
            case 3:
                err_12 = _a.sent();
                return [4, (0, effects_1.put)(actions.userPwResetAction.failure(err_12))];
            case 4:
                _a.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.userPasswordReset = userPasswordReset;
function userVerification(action) {
    var err_13, portalError;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 6]);
                return [4, (0, effects_1.call)(api_client_1.client.post, "/user/".concat(action.payload, "/verification_email"))];
            case 1:
                _a.sent();
                return [4, (0, effects_1.put)(actions.userVerificationAction.success())];
            case 2:
                _a.sent();
                setTimeout(function () { return antd_1.message.success('A verification email has been sent to the user.'); }, 100);
                return [3, 6];
            case 3:
                err_13 = _a.sent();
                portalError = (0, common_1.getPortalError)(err_13);
                return [4, (0, effects_1.put)(actions.userVerificationAction.failure(portalError))];
            case 4:
                _a.sent();
                return [4, (0, effects_1.call)([antd_1.message, 'success'], portalError.customError)];
            case 5:
                _a.sent();
                return [3, 6];
            case 6: return [2];
        }
    });
}
exports.userVerification = userVerification;
function getDeactivationUsers() {
    var usersDeactivation, err_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4, (0, effects_1.call)(api_client_1.client.get, '/user/user_deactivations')];
            case 1:
                usersDeactivation = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.userDeactivationRequestAction.success(usersDeactivation))];
            case 2:
                _a.sent();
                return [3, 5];
            case 3:
                err_14 = _a.sent();
                return [4, (0, effects_1.put)(actions.userDeactivationRequestAction.failure(err_14))];
            case 4:
                _a.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.getDeactivationUsers = getDeactivationUsers;
function createUserDeactivations(action) {
    var _a, userIds, _b, deactivationReason, createDeactivations, err_15;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                _a = action.payload, userIds = _a.userIds, _b = _a.deactivationReason, deactivationReason = _b === void 0 ? auth_client_1.UserDeactivationReason.UserAction : _b;
                return [4, (0, effects_1.call)(api_client_1.client.post, '/user/user_deactivations', {
                        deactivationReason: deactivationReason,
                        userIds: userIds,
                    })];
            case 1:
                createDeactivations = (_c.sent()).data;
                return [4, (0, effects_1.put)(actions.createUserDeactivationsAction.success(createDeactivations))];
            case 2:
                _c.sent();
                setTimeout(function () { return antd_1.message.success('The User Deactivations Successfully Updated'); }, 100);
                return [3, 5];
            case 3:
                err_15 = _c.sent();
                return [4, (0, effects_1.put)(actions.createUserDeactivationsAction.failure(err_15))];
            case 4:
                _c.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.createUserDeactivations = createUserDeactivations;
function deleteUserDeactivation(action) {
    var deactivationIds, deleteDeactivations, err_16;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                deactivationIds = action.payload.deactivationIds;
                return [4, (0, effects_1.call)(api_client_1.client.put, '/user/user_deactivations', { deactivationIds: deactivationIds })];
            case 1:
                deleteDeactivations = (_a.sent()).data;
                return [4, (0, effects_1.put)(actions.deleteUserDeactivationAction.success(deleteDeactivations))];
            case 2:
                _a.sent();
                setTimeout(function () { return antd_1.message.success('The User Deactivations Successfully Updated'); }, 100);
                return [3, 5];
            case 3:
                err_16 = _a.sent();
                return [4, (0, effects_1.put)(actions.deleteUserDeactivationAction.failure(err_16))];
            case 4:
                _a.sent();
                return [3, 5];
            case 5: return [2];
        }
    });
}
exports.deleteUserDeactivation = deleteUserDeactivation;
function sendDemandContactUsRequestEmail(action) {
    var _a, accountName, type, err_17;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 7]);
                _a = action.payload, accountName = _a.accountName, type = _a.type;
                return [4, (0, effects_1.call)(api_client_1.client.post, 'email/demand/contact-us-request', {
                        accountName: accountName,
                        type: type,
                    })];
            case 1:
                _b.sent();
                return [4, (0, effects_1.put)(actions.sendUserDemandContactUsRequestEmailAction.success(type))];
            case 2:
                _b.sent();
                return [4, (0, effects_1.call)(antd_1.message.success, 'Your request is submitted successfully!')];
            case 3:
                _b.sent();
                return [3, 7];
            case 4:
                err_17 = _b.sent();
                return [4, (0, effects_1.put)(actions.sendUserDemandContactUsRequestEmailAction.failure(err_17))];
            case 5:
                _b.sent();
                return [4, (0, effects_1.call)(antd_1.message.error, 'An error occurred!')];
            case 6:
                _b.sent();
                return [3, 7];
            case 7: return [2];
        }
    });
}
exports.sendDemandContactUsRequestEmail = sendDemandContactUsRequestEmail;
function sendUserCreationLimitChangeRequestEmail() {
    var err_18;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 7]);
                return [4, (0, effects_1.call)(api_client_1.client.post, 'email/scale/user-creation-limit-change-request')];
            case 1:
                _a.sent();
                return [4, (0, effects_1.put)(actions.sendUserCreationLimitChangeRequestEmailAction.success())];
            case 2:
                _a.sent();
                return [4, (0, effects_1.call)(antd_1.message.success, 'Your request is submitted successfully!')];
            case 3:
                _a.sent();
                return [3, 7];
            case 4:
                err_18 = _a.sent();
                return [4, (0, effects_1.put)(actions.sendUserCreationLimitChangeRequestEmailAction.failure(err_18))];
            case 5:
                _a.sent();
                return [4, (0, effects_1.call)(antd_1.message.error, 'An error occurred!')];
            case 6:
                _a.sent();
                return [3, 7];
            case 7: return [2];
        }
    });
}
exports.sendUserCreationLimitChangeRequestEmail = sendUserCreationLimitChangeRequestEmail;
function usersSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.GET_ALL_USER_DEACTIVATION_REQUEST, getDeactivationUsers)];
            case 1:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.CREATE_USER_DEACTIVATIONS_REQUEST, createUserDeactivations)];
            case 2:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.DELETE_USER_DEACTIVATIONS_REQUEST, deleteUserDeactivation)];
            case 3:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.GET_RICH_TOKEN_BY_UUID_REQUEST, getRichAccessTokenByUuid)];
            case 4:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.GET_RICH_TOKEN_BY_ID_REQUEST, getRichAccessTokenById)];
            case 5:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.DELETE_TOKEN_BY_UUID_REQUEST, deleteAccessToken)];
            case 6:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.GET_ACCESS_BY_UUID_REQUEST, getUserAccessByUuidRequest)];
            case 7:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.GET_ALL_REQUEST, getUsers)];
            case 8:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.GET_ACCESS_ALL_REQUEST, getUsersAccess)];
            case 9:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.CREATE_REQUEST_CLIENT, createUserSaga)];
            case 10:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.TOGGLE_DUPLICATE, toggleDuplicate)];
            case 11:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.GET_BY_UUID_REQUEST, getUserByUuid)];
            case 12:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.UPDATE_REQUEST, updateUserRequest)];
            case 13:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.PW_RESET_REQUEST, userPasswordReset)];
            case 14:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.GET_VERIFICATION_REQUEST, userVerification)];
            case 15:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.SEND_DEMAND_USER_CONTACT_US_REQUEST_EMAIL_REQUEST, sendDemandContactUsRequestEmail)];
            case 16:
                _a.sent();
                return [4, (0, effects_1.takeLatest)(actionTypes_1.UserActionType.SEND_USER_CREATION_LIMIT_CHANGE_REQUEST_EMAIL_REQUEST, sendUserCreationLimitChangeRequestEmail)];
            case 17:
                _a.sent();
                return [2];
        }
    });
}
exports.usersSaga = usersSaga;
